import * as frontEndLogger from "./logger.utils";
const getMetadata = () => {
    return {
        applicationName: process?.env?.REACT_APP_NAME || document?.title,
        pageTitle: document?.title,
        pageUrl: window.location.href,
    };
};
/* All unhandled exceptions in the consuming Frontend
that have an error object will be caught and logged from here */
window.addEventListener("error", function (event) {
    if (event.error) {
        if (event.error.hasBeenCaught !== undefined) {
            return false;
        }
        event.error.hasBeenCaught = true;
        error({ message: "unhandled exception", error: event.error });
    }
});
const info = (params) => frontEndLogger.info(params, getMetadata());
const debug = (params) => frontEndLogger.debug(params, getMetadata());
const warn = (params) => frontEndLogger.warn(params, getMetadata());
const error = (params) => frontEndLogger.error(params, getMetadata());
export const logger = {
    info,
    debug,
    warn,
    error,
};
//# sourceMappingURL=logger.js.map